var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhyBuyWarranty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8272 14.2197L14.1253 16.2202L17.5612 11.4077",
    stroke: "#13294B",
    strokeWidth: 1.3195,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8156 13.5C21.8156 17.1927 18.5857 20.2652 14.5004 20.2652C10.4151 20.2652 7.18514 17.1927 7.18514 13.5C7.18514 9.80725 10.4151 6.73473 14.5004 6.73473C18.5857 6.73473 21.8156 9.80725 21.8156 13.5Z",
    stroke: "#13294B",
    strokeWidth: 1.3195
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9864 2.9912C17.1481 3.1293 17.3664 3.18099 17.5729 3.13007L20.8324 2.32605L21.9614 5.24957C22.0417 5.45756 22.2216 5.61091 22.4397 5.65724L25.6891 6.34751L25.236 9.38133C25.2012 9.61428 25.2932 9.84811 25.4775 9.99485L27.9758 11.9847L26.0683 14.4646C25.9226 14.654 25.8907 14.9073 25.9848 15.1269L27.1998 17.9604L24.2442 19.3444C24.0361 19.4418 23.8937 19.6404 23.8683 19.8687L23.5261 22.9356L20.171 22.8814C19.9542 22.8779 19.7495 22.9812 19.6234 23.1576L17.7634 25.762L14.7995 24.2521C14.6113 24.1563 14.3887 24.1563 14.2005 24.2521L11.2366 25.762L9.37655 23.1576C9.25052 22.9812 9.04584 22.8779 8.82903 22.8814L5.47389 22.9356L5.13174 19.8687C5.10627 19.6404 4.96387 19.4418 4.75583 19.3444L1.80021 17.9604L3.01517 15.1269C3.10931 14.9073 3.0774 14.654 2.93175 14.4646L1.02417 11.9847L3.52253 9.99485C3.70677 9.84811 3.79881 9.61428 3.76402 9.38133L3.31092 6.34751L6.56026 5.65724C6.77835 5.61091 6.95829 5.45756 7.03862 5.24957L8.16764 2.32605L11.4271 3.13007C11.6336 3.18099 11.8519 3.1293 12.0136 2.9912L14.5 0.867627L16.9864 2.9912Z",
    stroke: "#13294B",
    strokeWidth: 1.3195,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyBuyWarranty);
export default __webpack_public_path__ + "static/media/why-buy-warranty.6f4d7a47.svg";
export { ForwardRef as ReactComponent };